exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-group .mat-input-container {\r\n  width: 100%;\r\n  font-size: 16px;\r\n}\r\n.mat-input-wrapper .mat-input-prefix .icon-form {\r\n  position: relative;\r\n  margin-right: 15px;\r\n}\r\n.mat-input-element {\r\n  height: 20px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Work-Local/frontend/src/assets/css/login.css
// module id = ../../../../../src/assets/css/login.css
// module chunks = main